import { memo } from 'react';
import {Field} from "react-final-form";
import {Checkbox} from "../inputs";

const CheckboxField = memo((props) => (
  <Field
    {...props}
    render={({input, meta}) => (
      <Checkbox {...props} {...input} errors={meta.submitError} />
    )}
  />
));

CheckboxField.propTypes = Checkbox.propTypes;
CheckboxField.defaultProps = Checkbox.defaultProps;

export default CheckboxField;
